
let morfpsIsLoading = false;

document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".morfps__button");
  if (!btn || morfpsIsLoading) return;

  e.preventDefault();

  const href = btn.getAttribute("href");
  const url = new URL(href, window.location.origin);
  const handle = url.pathname.split("/products/")[1]?.split("?")[0];
  if (!handle) return;

  const currentRerender = document.querySelector(".shopify-section--main-product product-rerender");
  if (!currentRerender) return;

  morfpsIsLoading = true;

  const allButtons = document.querySelectorAll(".morfps__button");
  allButtons.forEach(b => b.classList.add(b === btn ? "morfps--active" : "morfps--blocked"));

  currentRerender.style.opacity = "0.5";

  try {
    const res = await fetch(`/products/${handle}?sections=render-main-product,reviews-widget`);
    const data = await res.json();

    const html = data["render-main-product"];
    if (!html) throw new Error("[morfps] empty section response");

    const temp = document.createElement("div");
    temp.innerHTML = html;
    const newRerender = temp.querySelector("product-rerender");
    if (!newRerender) throw new Error("[morfps] product-rerender not found in response");

    currentRerender.replaceWith(newRerender);
    history.pushState({}, "", href);
    Shopify?.PaymentButton?.init();

    const widgetHtml = data["reviews-widget"];
    if (widgetHtml) {
      const widgetTemp = document.createElement("div");
      widgetTemp.innerHTML = widgetHtml;
      const newWidget = widgetTemp.querySelector(".reviews_widget--pdp");
      if (newWidget) {
        const currentWidget = document.querySelector(".reviews_widget--pdp");
        if (currentWidget) currentWidget.replaceWith(newWidget);
      }
    }
    appstle_jQuery('[id^="appstle_subscription_widget"]').remove();
    initVolumeDiscountAppstleBundle();
    jdgmCacheServer.reloadAll();

  } catch (err) {
    console.error("[morfps]", err);
    currentRerender.style.opacity = "";
  } finally {
    morfpsIsLoading = false;
    document.querySelector('.reviews_widget--pdp')?.classList.remove('loading');
    allButtons.forEach(b => b.classList.remove("morfps--active", "morfps--blocked"));
  }
});

document.addEventListener('DOMContentLoaded', function() {

  window.onload = function() {
      jdgmCacheServer.reloadAll();
      document.querySelector('.reviews_widget--pdp')?.classList.remove('loading');
      initVolumeDiscountAppstleBundle();
  };
});